export function getStringParam(param: string | string[] | undefined): string {
	return typeof param === 'string' ? param : '';
}
